/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCollateralHoldingRequest } from './ClaimCollateralHoldingRequest';
import {
    ClaimCollateralHoldingRequestFromJSON,
    ClaimCollateralHoldingRequestFromJSONTyped,
    ClaimCollateralHoldingRequestToJSON,
    ClaimCollateralHoldingRequestToJSONTyped,
} from './ClaimCollateralHoldingRequest';
import type { ClaimCollateralType } from './ClaimCollateralType';
import {
    ClaimCollateralTypeFromJSON,
    ClaimCollateralTypeFromJSONTyped,
    ClaimCollateralTypeToJSON,
    ClaimCollateralTypeToJSONTyped,
} from './ClaimCollateralType';

/**
 * 
 * @export
 * @interface ClaimCollateralRequest
 */
export interface ClaimCollateralRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    id: string | null;
    /**
     * 
     * @type {ClaimCollateralType}
     * @memberof ClaimCollateralRequest
     */
    type: ClaimCollateralType;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    holdingId: string | null;
    /**
     * 
     * @type {ClaimCollateralHoldingRequest}
     * @memberof ClaimCollateralRequest
     */
    newHolding: ClaimCollateralHoldingRequest | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimCollateralRequest
     */
    details: string | null;
}



/**
 * Check if a given object implements the ClaimCollateralRequest interface.
 */
export function instanceOfClaimCollateralRequest(value: object): value is ClaimCollateralRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('holdingId' in value) || value['holdingId'] === undefined) return false;
    if (!('newHolding' in value) || value['newHolding'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function ClaimCollateralRequestFromJSON(json: any): ClaimCollateralRequest {
    return ClaimCollateralRequestFromJSONTyped(json, false);
}

export function ClaimCollateralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCollateralRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ClaimCollateralTypeFromJSON(json['type']),
        'holdingId': json['holdingId'],
        'newHolding': ClaimCollateralHoldingRequestFromJSON(json['newHolding']),
        'details': json['details'],
    };
}

export function ClaimCollateralRequestToJSON(json: any): ClaimCollateralRequest {
    return ClaimCollateralRequestToJSONTyped(json, false);
}

export function ClaimCollateralRequestToJSONTyped(value?: ClaimCollateralRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ClaimCollateralTypeToJSON(value['type']),
        'holdingId': value['holdingId'],
        'newHolding': ClaimCollateralHoldingRequestToJSON(value['newHolding']),
        'details': value['details'],
    };
}

